// extracted by mini-css-extract-plugin
module.exports = {"link-icon":"modal-add-telegram_link-icon__IOzb8"};